<div class="one" fxLayout="column" [formGroup]="MatterConveyancingDetailsForm">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto" class="checkbox-row">
    <mat-checkbox class="checkbox-width" formControlName="IMPROVEMENTTOWNHOUSE">
      Townhouse
    </mat-checkbox>
    <mat-checkbox class="checkbox-width" formControlName="IMPROVEMENTHOUSE">House</mat-checkbox>
    <mat-checkbox class="checkbox-width" formControlName="IMPROVEMENTGARAGE">Garage</mat-checkbox>
    <mat-checkbox class="checkbox-width" formControlName="IMPROVEMENTCARPORT">Carport</mat-checkbox>
    <mat-checkbox class="checkbox-width" formControlName="IMPROVEMENTHOMEUNIT">
      HomeUnit
    </mat-checkbox>
    <mat-checkbox class="checkbox-width" formControlName="IMPROVEMENTSTORAGESPACE">
      StorageSpace
    </mat-checkbox>
    <mat-checkbox class="checkbox-width" formControlName="IMPROVEMENTOTHER">Other</mat-checkbox>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field appearance="outline" fxFlex="45" class="pr-1">
      <mat-label>No Of Car Spaces</mat-label>
      <input matInput formControlName="IMPROVEMENTNOOFCARSPACES" type="number" />
    </mat-form-field>
    <mat-form-field appearance="outline" fxFlex="55" class="pr-1">
      <mat-label>Details</mat-label>
      <input matInput formControlName="IMPROVEMENTOTHERDETAILS" type="text" />
    </mat-form-field>
  </div>
</div>
